define('views/modules/goal/edit/types/main-goal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/form/textbox',
    'views/parts/form/select',
    'views/parts/form/datepicker',
    // templates
    'text!templates/modules/goal/edit/types/main-goal.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VTextBox,
    VSelect,
    VDatePicker,
    // templates
    TMainGoal
) {

    var VMainGoal = Backbone.View.extend({
        template: TMainGoal,

        regions: {
            type: '.type-input',
            endValue: '.end-value-input',
            startValue: '.start-value-input',
            endDate: '.end-date-input',
        },

        initialize: function(opt) {
            opt = opt || {};
            var profile = this.profile = opt.profile,
                startValueLabel = opt.startValueLabel,
                endValueAttr = opt.endValueAttr,
                startValueAttr = opt.startValueAttr,
                startValueHelp = opt.startValueHelp;

            var model = this.model,
                view = this.view = {
                    type: new VSelect({
                        labelposition: "top",
                        option: { label: 'label', value: 'value' },
                        attribute: 'type',
                        model: model,
                        collection: model.getTypes(),
                        onChange: this.onTypeChange,
                        context: this,
                    }),
                    endValue: new VTextBox({
                        label: this.getEndValueLabel(),
                        labelposition: "top",
                        attribute: endValueAttr || 'goalTarget',
                        model: model,
                        addon: true,
                        addonAfter: '-',
                        type: 'number',
                    }),
                    startValue: new VTextBox({
                        label: startValueLabel || this.getStartValueLabel(),
                        labelposition: "top",
                        attribute: startValueAttr || 'start',
                        model: model,
                        addon: true,
                        addonAfter: '-',
                        type: 'number',
                        help: startValueHelp,
                    }),
                    endDate: new VDatePicker({ label: 'goal:By this date', labelposition: "top", attribute: 'endDate', model: model }),
                };

            this.listenTo(profile, 'sync', this.render)
                .listenTo(model, 'model:reset', this.onModelReset);
        },
        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                isDistance: this.model.getType() === 'distance'
            })));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.endValue, zone.$endValue)
                .assign(view.startValue, zone.$startValue)
                .assign(view.type, zone.$type)
                .assign(view.endDate, zone.$endDate);

            this.setUnitAddons();

            if (this.model.getType() !== 'custom')
              this.disableInputs();

            return this;
        },

        disableInputs: function() {


            var view = this.view,
                model = this.model,
                isNewModel = model.isNew();

            view.type.setDisable(!isNewModel);
            view.startValue.setDisable(!isNewModel);
            return this;
        },

        setUnitAddons: function() {
            var view = this.view,
                model = this.model,
                unit = model.isNew() ? this.profile.get(model.getProfileUnitAttr()) : model.get('goalUnit');

            view.startValue.setAddonAfter(unit);
            view.endValue.setAddonAfter(unit);
            return this;
        },

        getStartValueLabel: function() {
            var type = this.model.getType();
            if (type === 'waistline') return 'goal:My waistline is';
            if (type === 'weight') return 'goal:My bodyweight is';
        },

        getEndValueLabel: function() {
            return this.model.isDistance() ? 'I want to travel' : 'goal:My goal is to reach';
        },

        hideStartValue: function(hide) {
          this.view.startValue.zone.$root["0"].hidden = hide;
        },

        ////////////
        // events //
        ////////////

    });

    return VMainGoal;
});

